import { render, staticRenderFns } from "./PublicChats.vue?vue&type=template&id=2e0f69f6&scoped=true&"
import script from "./PublicChats.vue?vue&type=script&lang=js&"
export * from "./PublicChats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e0f69f6",
  null
  
)

export default component.exports